var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9140_11550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6577 13.6594C16.7833 10.5338 16.7833 5.46622 13.6577 2.34065C10.5322 -0.784928 5.46462 -0.784928 2.33904 2.34065C-0.786534 5.46622 -0.786534 10.5338 2.33904 13.6594C5.46462 16.7849 10.5322 16.7849 13.6577 13.6594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.246 2.99951L9.022 9.83151H6.992C6.97333 9.01951 6.894 6.74218 6.754 2.99951H9.246ZM9.204 11.7075C9.204 12.0248 9.08733 12.3002 8.854 12.5335C8.62066 12.7575 8.34533 12.8695 8.028 12.8695C7.692 12.8695 7.40266 12.7575 7.16 12.5335C6.91733 12.3002 6.796 12.0248 6.796 11.7075C6.796 11.3715 6.91733 11.0868 7.16 10.8535C7.40266 10.6108 7.692 10.4895 8.028 10.4895C8.34533 10.4895 8.62066 10.6108 8.854 10.8535C9.08733 11.0868 9.204 11.3715 9.204 11.7075Z",
    fill: "#E11D48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9140_11550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9a82a6f652edb8679bca0693dde39370.svg";
export { ForwardRef as ReactComponent };